<template>
    <!-- <div v-if="show" class="guide-page" @click=" doClose"> -->
    <div v-if="show" :class="['guide-page',NODE_ENV === 'erp-prod'?'isErp':'']" @click=" doClose">
    <div class="steps">
      <div class="step" :class="{'hide-step': hide}">
        <div class="step-bar" @click.prevent.stop="doStep(1)"></div>
        <div class="step-tips" @click.prevent.stop>
          点击这个圆圈在地图上圈出一个范围，可以看到这个范围的在营业企业哦～
          <div class="actions">
            <el-button w100 type="dialog-cancel" @click=" doClose">跳过提醒</el-button>
            <el-button w100 type="dialog-confirm" @click="doAlwaysClose">不再提醒</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import changeModal from "@/utils/zdModal"

export default {
  name: "mapGuidePage",
  model: {
    prop: 'show',
    event: 'showChange'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    show: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        changeModal(val)
      }
    },
  },
  components: {},
  data() {
    return {
      hide: false,
      NODE_ENV: ''
    };
  },
  computed: {
  },
  created() {
  },
  mounted() {
    if (this.$route.query.hide) this.hide = true
    this.NODE_ENV = process.env.NODE_ENV
  },
  methods: {
    doStep(step) {
      this.$emit('onStep', step)
      this.doClose()
    },
    doClose() {
      this.$emit('showChange', false)
    },
    doAlwaysClose() {
      this.$emit('alwaysClose')
      this.doClose()
    }

  },
  beforeDestroy(){
    // changeModal(false)
  }

}

</script>
<style lang='scss' scoped>
.guide-page {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
  &.isErp{
     .step{
        &:first-child{
          top: 166px;
          left: 369px;
        }
     }
  }
}
// .notice {
//   position: absolute;
//   right: 24px;
//   top: 80px;
//   width: 240px;
//   padding: 12px;
//   background: #f4f4f4;
//   border-radius: 5px;
//   box-shadow: 1px 1px 3px #0000004c;
//   .close {
//     position: absolute;
//     right: 12px;
//     top: 12px;
//     width: 30px;
//     height: 30px;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     cursor: pointer;
//   }
//   .title {
//     line-height: 30px;
//     font-size: 16px;
//   }
//   .actions {
//     margin-top: 12px;
//   }
// }

.step:first-child {
  position: absolute;
  // top: 132px;
  // left: 316px;
  top: 151px;
    left: 417px;
  .step-bar {
    position: absolute;
    top: -12px;
    left: 2px;
    width: 48px;
    height: 48px;
    background-size: 36px 36px;
    background-position: center;
    background-image: url("~@/assets/gbIcon/click.png");
    background-repeat: no-repeat;
    cursor: pointer;
    animation: bar-scale 2s infinite;
    animation-direction: alternate; /*轮流反向播放动画。*/
    animation-timing-function: linear; /*动画的速度曲线*/
  }
  .step-tips {
    padding: 24px 24px;
    position: absolute;
    top: 38px;
    // box-shadow: 1px 1px 3px #0000004c;
    // left: -15px;
     width: 326px;
     height: 144px;
    background: #FFFFFF;
    border-radius: 10px;
    font-weight: 400;
    color: #333333;
    line-height: 18px;
    font-size: 13px;
    left: 6px;
  }
  .actions {
    margin-top: 24px;
    // display: flex;
    // justify-content: center;
    float: right;
  }
  .step-tips{
       .el-button.is-w100{
          padding: 0 !important;
          height: 36px;
        }
        .el-button + .el-button{
          margin-left: 30px;
        }
  }
}

@keyframes bar-scale {
  0% {
    transform: scale(0.85); /*开始为原始大小*/
  }
  25% {
    transform: scale(1.05); /*放大1.1倍*/
  }
  50% {
    transform: scale(0.85);
  }
  75% {
    transform: scale(1.05);
  }
}
.step.hide-step {
  top: 64px;
left: 177px;
}
</style>
